import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ToggleSidenavCollapsedAction } from 'src/app/actions/sidenav.actions';
import { Sidenav } from 'src/app/models/sidenav.model';
import { SidenavItem } from 'src/app/shared/enums/sidenav-item.enum';
import { environment } from 'src/environments/environment';
import * as fromRoot from '../../../reducers';
import {AlertCount} from '../../../models/alert-count';
import {AsyncPipe, NgClass} from "@angular/common";
import {MatBadge} from "@angular/material/badge";
import {MatIcon} from "@angular/material/icon";
import {SettingsComponent} from "../../settings/settings.component";
import {MatDivider} from "@angular/material/divider";

@Component({
  selector: 'colimo-collapsed-sidenav',
  templateUrl: './collapsed-sidenav.component.html',
  styleUrls: ['./collapsed-sidenav.component.scss'],
  imports: [
    NgClass,
    AsyncPipe,
    MatBadge,
    MatIcon,
    SettingsComponent,
    MatDivider,
  ]
})
export class CollapsedSidenavComponent implements OnInit {
  @Input() public alertCount: AlertCount;
  @Input() public alertsConfigured: boolean;
  @Input() public colimindAccess: boolean;
  @Output() public initiateLogout = new EventEmitter<void>();
  public sidenavCollapsed: boolean;
  public adminToolPath: string;
  public sidenav$: Observable<Sidenav>;
  public sidenavItems = SidenavItem;
  public colimindActive = false;

  constructor(private router: Router, private store: Store<fromRoot.State>) {}

  public ngOnInit(): void {
    this.sidenav$ = this.store.select(fromRoot.getSidenav);
    this.store.select(fromRoot.getSidenav).subscribe((sidenav: Sidenav) => {
      this.sidenavCollapsed = sidenav.sidenavCollapsed;
    });
    this.adminToolPath = environment.adminPath;
    this.colimindActive = environment.colimind.colimindActive;
  }

  public openView(route: SidenavItem) {
    this.router.navigate(['/' + route]);
  }

  public toggleSidenavCollapsed(): void {
    this.store.dispatch(new ToggleSidenavCollapsedAction(!this.sidenavCollapsed));
  }

  public logout(): void {
    this.initiateLogout.emit();
  }
}
